<template>
    <div>
        <v-dialog
            v-model="warningDialog"
            width="500"
        >
            <v-card>
                <v-card-title
                    primary-title
                    class="headline"
                >
                    Warning
                </v-card-title>
                <v-card-text>
                    <p class="text-capitalize body-2" v-for="(error, index) in errorMsgs" :key="index">
                        {{ error }}
                    </p>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="bindezcolor"
                        :ripple="false"
                        depressed
                        dark
                        @click="warningDialog=false"
                    >
                        Got it!
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-card md12 flat style="top: 8px;">
            <v-card-title v-if="!create" primary-title>
                <div style="padding-left: 10px;">
                    <h2 class="subheading font-weight-medium">
                        Monitor : <span class="monitor-title--color">{{monitor.name !== undefined ? monitor.name : 'Monitor' | unescapeString }}</span>
                    </h2>
                    <span class="caption description--color">Created: {{monitor.created_at | formatCreatedAt }}</span>
                </div>
            </v-card-title>
            <v-container fluid>
                <v-tabs active-class="tabs-active" v-model="active" hide-slider>
                    <v-tab class="custom-border font-weight-regular"><span class="text-capitalize">General</span></v-tab>
                    <v-tab class="custom-border font-weight-regular" :disabled="(!monitorFetchReady && !create) || generalSectionInvalid"><span class="text-capitalize">Keywords</span></v-tab>
                    <v-tab class="custom-border font-weight-regular" :disabled="(!monitorFetchReady && !create) || (generalSectionInvalid || keywordSectionInvalid)"><span class="text-capitalize">Source</span></v-tab>
                    <v-tab class="custom-border font-weight-regular" :disabled="(!monitorFetchReady && !create) || (generalSectionInvalid || keywordSectionInvalid || sourceSectionInvalid) || authenticatedUser.is_user"><span class="text-capitalize">Teams</span></v-tab>
					<!-- TODO: uncomment when BE is ready -->
                    <v-tab class="custom-border font-weight-regular"><span class="text-capitalize">Facebook Connect</span></v-tab>
                    <v-tab-item class="pa-3 tab-item-border">
                        <GeneralSection @next="next" :create="create" :processing="processing"/>
                    </v-tab-item>
                    <v-tab-item class="pa-3 tab-item-border">
                        <KeywordsSection @next="next" :create="create" :processing="processing"/>
                    </v-tab-item>
                    <v-tab-item class="pa-3 tab-item-border">
                        <SourcesSection @next="next" :create="create" :processing="processing"/>
                    </v-tab-item>
                    <v-tab-item class="pa-3 tab-item-border">
                        <TeamsSection :create="create" @next="next" :processing="processing"/>
                    </v-tab-item>
					<!-- TODO: uncomment when BE is ready -->
                    <v-tab-item class="pa-3 tab-item-border">
                        <FacebookConnectSection/>
                    </v-tab-item>
                </v-tabs>
            </v-container>
        </v-card>
    </div>
</template>

<script>
	/* eslint-disable */
	import GeneralSection from '@/components/MonitorSettings/GeneralSection'
	import KeywordsSection from "@/components/MonitorSettings/KeywordsSection"
	import TeamsSection from "@/components/MonitorSettings/TeamsSection"
	import SourcesSection from "@/components/MonitorSettings/SourcesSection"
	import FacebookConnectSection from "@/components/globalsettings/FacebookConnectSection"
	import {mapActions, mapState, mapMutations} from 'vuex'
    import authCurrentUser from "../mixins/authCurrentUser";
	import moment from 'moment'
    import _debounce from 'lodash/debounce'
    import _isEmpty from 'lodash/isEmpty'


	export default {
		name: "MonitorSetting",
		props: ['create'],
		data() {
			return {
				active: 0,
                errorMsgs: [],
                warningDialog: false,
                processing: false
			}
		},
        mixins:[authCurrentUser],
		validations: {},
		computed: {
			...mapState('monitors', [
				'name',
				'owner',
				'pages',
				'keywords',
				'keywordSectionInvalid',
				'description',
				'generalSectionInvalid',
				'sourceSectionInvalid',
				'assignedUser',
				'industry_uuid',
				'monitorFetchReady',
                'monitorType'
			]),
			...mapState([
				'monitor'
			]),
            warningMessages:{
				get(){
					return this.errorMsgs;
                },
                set(val){
					this.errorMsgs = val;
                }
            }
		},

		methods: {
			...mapActions('monitors', [
				'createMonitor',
				'updateMonitor',
				'getUsersWithAccessToMonitor',
				'updateUserMonitorAccess'
			]),

			...mapActions([
				'fetchMonitor',
			]),

			...mapMutations('monitors', [
				'setMonitorName',
				'setMonitorIndustry',
				'setMonitorDescription',
				'setMonitorKeywords',
				'setMonitorSources',
				'setMonitorOwner',
				'setReady',
				'setUsers',
				'assignUserToMonitor',
                'setDefaultState',
                'setMonitorType'
			]),

            ...mapMutations([
            	'setMonitor'
            ]),

            ...mapMutations('error',[
            	"setErrorDialogStatus",
                "setErrorDialogMessage",
                "setErrorStatusCode",
            ]),

			next(val) {
				const active = parseInt(this.active)
				if (val === 'update') {
					this.actionMonitor()
						.catch(res => {
							let {response: {status, data: {errors}}} = res;
							console.log(Object.values(errors));
							this.setErrorDialogStatus(true);
							this.setErrorDialogMessage(errors[0].error.message);
							this.setErrorStatusCode(status);
						})
						.finally(_ => {
							this.processing = false
						})
				} else {
					this.active = (active < 3 ? active + 1 : 0)
				}
			},

			updateUserAccess(monitor_uuid) {
				let monitor_access = this.assignedUser.map(asuser => ({
					user_uuid: asuser.user_uuid,
					access: asuser.access
				}))
				return this.updateUserMonitorAccess({monitor_uuid, monitor_access})
			},

			actionMonitor:_debounce(function(){
				let data = {
					industry_uuid: this.industry_uuid,
					name: this.name,
					description: this.description,
					keywords: this.keywords,
					pages: this.pages,
                    // type: this.monitorType
				};
				data.user_uuid = this.authenticatedUser.is_superadministrator ? this.owner : this.authenticatedUser.uuid
				if (this.create) {
					// this.$ua.trackEvent("Create New Monitor", "click");
                    this.processing = true;
					return this.createMonitor(data)
						.then(({data}) => {
							// this.authenticatedUser.is_administrator && !_.isEmpty(this.assignedUser)
							if ((this.authenticatedUser.is_administrator || this.authenticatedUser.is_superadministrator) && !_isEmpty(this.assignedUser)) {
								this.updateUserAccess(data.monitor).then(() => {
									this.processing = false;
									this.$ua.trackEvent("Create New Monitor", "click", `${this.authenticatedUser.email || 'User'} create new monitor(${data.monitor || 'Monitor'}) and assigned users to monitor`);
									this.$router.push({name: 'mention', params: {monitor_uuid: data.monitor}})
								})
							} else {
								this.$ua.trackEvent("Create New Monitor", "click", `${this.authenticatedUser.email || 'User'} create new monitor(${data.monitor || 'Monitor'}).`);
								this.$router.push({name: 'mention', params: {monitor_uuid: data.monitor}});
							}
						})
						.catch(res => {
							return Promise.reject(res);
						});
				} else {
					if(this.authenticatedUser.is_user){
						this.warningDialog = true;
						this.warningMessages = ["You need to be admin to edit monitor"];
						return
					}
					this.processing = true;
					// this.$ua.trackEvent("Update Existing Monitor", "click");
					//data.user_uuid = this.authenticatedUser.is_superadministrator ? this.owner : this.authenticatedUser.uuid;
					return this.updateMonitor({data, monitor_uuid: this.$route.params.monitor_uuid})
						.then(({data}) => {
							this.setMonitor({data:data.monitor});
							///this.setMonitor(data.monitor);
							if ((this.authenticatedUser.is_administrator || this.authenticatedUser.is_superadministrator) && !_isEmpty(this.assignedUser)) {
								this.updateUserAccess(data.monitor.monitor_uuid)
									.then(() => {
										this.processing = false;
										this.$ua.trackEvent("Update Existing Monitor", "click", `${this.authenticatedUser.email || 'User'} update monitor(${data.monitor.monitor_uuid}) and assigned user to monitor.`);
										this.$router.push({name: 'mention', params: {monitor_uuid: data.monitor.monitor_uuid}});
									})
							} else {
								this.$ua.trackEvent("Update Existing Monitor", "click", `${this.authenticatedUser.email || 'User'} update monitor(${data.monitor.monitor_uuid}).`);
								this.$router.push({name: 'mention', params: {monitor_uuid: data.monitor.monitor_uuid}});
							}
						})
						.catch(res => {
							return Promise.reject(res);
						})
				}

			}, 500,{'leading':true})

		},
		components: {
			SourcesSection,
			KeywordsSection,
			GeneralSection,
			TeamsSection,
			FacebookConnectSection
		},

		created() {
			this.setDefaultState();
			if (this.$route.query.tab === 'facebook') {
				this.active = 4;
			}
			if (!this.create) {
				//this.setMonitor({});
                this.setMonitor({data:{}});
				this.setReady(false);
                //this.fetchMonitor(this.$route.params.monitor_uuid)
                this.fetchMonitor({monitor_uuid: this.$route.params.monitor_uuid})
					.then(_ => {
						this.setMonitorName(this.monitor.name);
						this.setMonitorDescription(this.monitor.description);
						this.setMonitorKeywords(this.monitor.keywords);
						this.setMonitorIndustry(this.monitor.industry_uuid);
						this.setMonitorSources(this.monitor.pages);
						this.setMonitorOwner(this.monitor.user_uuid);
						this.setReady(true);
						// this.setMonitorType(this.monitor.type || "keyword");
						if (this.authenticatedUser.is_administrator || this.authenticatedUser.is_superadministrator) {
							this.getUsersWithAccessToMonitor(this.monitor.monitor_uuid)
								.then(({data}) => {
									let assignedUser = data.users.map(user => ({
										status: user.status,
										name: user.name,
										email: user.email,
										user_uuid: user.uuid,
										access: user["monitors_with_access"][this.monitor.monitor_uuid]
									}));
									this.assignUserToMonitor(assignedUser)
								})
						}
					});
            }
		},

		filters: {
			formatCreatedAt(raw) {
				return moment(raw).format('DD MMMM YYYY')
			}
		},

	}
</script>

<style scoped>
	.custom-border {
		margin: 0 1.5px 0 1.5px;
		border-width: 1px 1px 0;
		border-color: #e5e7e9;
		border-style: solid;
		border-top-left-radius: 9px;
		border-top-right-radius: 9px;
	}

	.tab-item-border {
		border: 1px solid #e2e2e2;
		margin-left: 2px;
	}
</style>
